/**
 * Navigation Component
 * Side navigation drawer
 */

import React from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Divider,
  Typography
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  VideogameAsset as GamesIcon,
  Inbox as SubmissionsIcon,
  Translate as TranslateIcon,
  ContentCopy as CopyIcon,
  People as ContributorsIcon
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

const mainMenuItems = [
  { path: '/', label: 'Dashboard', icon: <DashboardIcon /> },
  { path: '/games', label: 'Games', icon: <GamesIcon /> },
  { path: '/submissions', label: 'Submissions', icon: <SubmissionsIcon /> },
  { path: '/contributors', label: 'Contributors', icon: <ContributorsIcon /> }
];

const toolsMenuItems = [
  { path: '/tools/translate', label: 'Translation', icon: <TranslateIcon /> },
  { path: '/tools/copy', label: 'Copy / Variant', icon: <CopyIcon /> }
];

export const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isSelected = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    if (path === '/games') {
      return location.pathname === '/games' || location.pathname.startsWith('/games/');
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Box
      sx={{
        width: 240,
        height: '100%',
        bgcolor: 'background.paper',
        borderRight: 1,
        borderColor: 'divider'
      }}
    >
      <List>
        {mainMenuItems.map((item) => (
          <ListItem key={item.path} disablePadding>
            <ListItemButton
              selected={isSelected(item.path)}
              onClick={() => navigate(item.path)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <Divider />

      <Box sx={{ px: 2, py: 1 }}>
        <Typography variant="caption" color="text.secondary">
          Tools
        </Typography>
      </Box>

      <List>
        {toolsMenuItems.map((item) => (
          <ListItem key={item.path} disablePadding>
            <ListItemButton
              selected={isSelected(item.path)}
              onClick={() => navigate(item.path)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
